<template>
    <DCard
        padding
    >
        <Form
            :payment-term="paymentTerm"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/PaymentTerms/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    paymentTerm: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.patch(route('settings.payment-terms.update', { paymentTerm: props.paymentTerm.payment_term }))
}
</script>
